import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useActiveCardStore = defineStore('activeCard', () => {
  const activeCardId = ref<string | null>(null)

  function setActiveCard(id: string) {
    activeCardId.value = id
  }

  function clearActiveCard() {
    activeCardId.value = null
  }

  return { activeCardId, setActiveCard, clearActiveCard }
})
